// src/pages/ReportsPage.js
import React, { useState, useEffect } from "react";
import { reportAPI } from "../api/api";
import toast from "react-hot-toast";
import "./ReportsPage.css";

const KN_MONTHS = [
  "","ಜನವರಿ","ಫೆಬ್ರವರಿ","ಮಾರ್ಚ್","ಏಪ್ರಿಲ್","ಮೇ","ಜೂನ್",
  "ಜುಲೈ","ಆಗಸ್ಟ್","ಸೆಪ್ಟೆಂಬರ್","ಅಕ್ಟೋಬರ್","ನವೆಂಬರ್","ಡಿಸೆಂಬರ್",
];

function fmtDate(d) {
  const dt = new Date(d);
  return `${String(dt.getDate()).padStart(2,"0")}/${String(dt.getMonth()+1).padStart(2,"0")}/${dt.getFullYear()}`;
}
function qtyDisp(qty, unitType) {
  qty = parseFloat(qty || 0);

  if (unitType === "kg")
    return `${qty.toFixed(3)} kg`;

   if (unitType === "L" || unitType === "litres")
    return `${qty.toFixed(3)} L`; 

  if (unitType === "rupees")
    return `₹${qty.toFixed(2)}`;

  if (unitType === "count")
    return `${qty.toFixed(0)} ಸಂ`;

  return `${qty.toFixed(3)}`;
}
// ReportsPage.js ನಲ್ಲಿ top ನಲ್ಲಿ ಸೇರಿಸಿ
function toDateStr(val) {
  if (!val) return '';
  // Already "YYYY-MM-DD" format
  if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}/)) {
    return val.slice(0, 10);
  }
  // Date object or other string — convert to YYYY-MM-DD
  const d = new Date(val);
  const year  = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day   = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const S = {
  page:     { padding:"24px 20px", maxWidth:1100, margin:"0 auto" },
  ctrl:     { display:"flex", gap:12, flexWrap:"wrap", alignItems:"flex-end",
              background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)",
              borderRadius:12, padding:"14px 16px", marginBottom:20 },
  lbl:      { fontSize:11, color:"#6b7280", marginBottom:4 },
  sel:      { background:"#1a2332", border:"1px solid rgba(255,255,255,0.12)",
              color:"#e5e7eb", borderRadius:8, padding:"7px 12px", fontSize:13 },
  secTitle: { fontSize:11, fontWeight:600, color:"#9ca3af", textTransform:"uppercase",
              letterSpacing:"0.06em", marginBottom:10, paddingBottom:6,
              borderBottom:"1px solid rgba(255,255,255,0.07)", display:"flex",
              alignItems:"center", gap:8 },
  tblWrap: { overflowX:"auto", borderRadius:10,
           border:"1px solid rgba(255,255,255,0.08)", marginBottom:20,
           WebkitOverflowScrolling:"touch" },

  sig:      { display:"flex", justifyContent:"space-between", marginTop:32,
              paddingTop:16, borderTop:"1px solid rgba(255,255,255,0.1)" },
};

function Btn({ onClick, disabled, children, variant="green" }) {
  const base = { padding:"8px 22px", borderRadius:8, fontSize:13, fontWeight:600,
                 cursor:disabled?"not-allowed":"pointer", opacity:disabled?0.6:1, border:"none" };
  const v = {
    green: { ...base, background:"rgba(74,222,128,0.15)", border:"1px solid rgba(74,222,128,0.4)", color:"#4ade80" },
    grey:  { ...base, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.15)", color:"#d1d5db" },
  };
  return <button style={v[variant]} onClick={onClick} disabled={disabled}>{children}</button>;
}

function Tab({ active, onClick, children }) {
  return (
    <button style={{
      padding:"9px 20px", borderRadius:8, fontSize:13,
      fontWeight:active?600:400, cursor:"pointer",
      border:active?"1px solid rgba(74,222,128,0.5)":"1px solid rgba(255,255,255,0.1)",
      background:active?"rgba(74,222,128,0.12)":"transparent",
      color:active?"#4ade80":"#9ca3af",
    }} onClick={onClick}>{children}</button>
  );
}

function SumCard({ icon, label, value, green }) {
  return (
    <div style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)",
                  borderRadius:12, padding:"14px 16px", display:"flex",
                  alignItems:"center", gap:12, minWidth:130 }}>
      <span style={{ fontSize:20 }}>{icon}</span>
      <div>
        <div style={{ fontSize:11, color:"#9ca3af", marginBottom:2 }}>{label}</div>
        <div style={{ fontSize:18, fontWeight:600, color:green?"#4ade80":"#f9fafb" }}>{value}</div>
      </div>
    </div>
  );
}

function GBadge({ name, order }) {
  const colors = [
    { bg:"#064e3b", fg:"#6ee7b7" }, { bg:"#1e3a5f", fg:"#93c5fd" },
    { bg:"#3b1f5e", fg:"#c4b5fd" }, { bg:"#3b1f1f", fg:"#fca5a5" },
  ];
  const c = colors[((order||1)-1) % colors.length];
  return (
    <span style={{ background:c.bg, color:c.fg, fontSize:11,
                   padding:"2px 8px", borderRadius:6, fontWeight:600, whiteSpace:"nowrap" }}>
      {name}
    </span>
  );
}

function RepTable({ heads, rows, totalRow }) {
  const th = { padding:"9px 12px", fontSize:12, color:"#9ca3af", fontWeight:500,
               borderBottom:"1px solid rgba(255,255,255,0.08)",
               background:"rgba(255,255,255,0.03)", whiteSpace:"nowrap" };
  const td = { padding:"8px 12px", fontSize:13, color:"#e5e7eb",
               borderBottom:"1px solid rgba(255,255,255,0.06)" };
  return (
    <div style={S.tblWrap} className="tbl-scroll-wrap">
      <table style={{ width:"100%", borderCollapse:"collapse" }}>
        <thead>
          <tr>{heads.map((h,i)=>(
            <th key={i} style={{...th, textAlign:h.num?"right":"left"}}>{h.label}</th>
          ))}</tr>
        </thead>
        <tbody>
          {rows.map((row,ri)=>(
            <tr key={ri} style={{ background:ri%2===0?"transparent":"rgba(255,255,255,0.02)" }}>
              {row.map((cell,ci)=>(
                <td key={ci} style={{...td, textAlign:heads[ci]?.num?"right":"left"}}>{cell}</td>
              ))}
            </tr>
          ))}
          {totalRow && (
            <tr style={{ background:"rgba(74,222,128,0.06)" }}>
              {totalRow.map((cell,ci)=>(
                <td key={ci} style={{...td, fontWeight:600, color:"#4ade80",
                  borderBottom:"none", textAlign:heads[ci]?.num?"right":"left"}}>{cell}</td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function RptHeader({ title, sub }) {
  return (
    <div style={{ background:"rgba(74,222,128,0.06)", border:"1px solid rgba(74,222,128,0.2)",
                  borderRadius:12, padding:"16px 20px", marginBottom:20 }}>
      <div style={{ fontSize:17, fontWeight:700, color:"#f9fafb" }}>{title}</div>
      {sub && <div style={{ fontSize:13, color:"#6ee7b7", marginTop:4 }}>{sub}</div>}
    </div>
  );
}

function SignBlock() {
  return (
    <div style={S.sig}>
      {["ಗುಮಾಸ್ತರ ಸಹಿ","ಮುಖ್ಯೋಪಾಧ್ಯಾಯರ ಸಹಿ"].map(l=>(
        <div key={l} style={{ textAlign:"center", minWidth:160 }}>
          <div style={{ borderBottom:"1px solid rgba(255,255,255,0.3)", marginBottom:6, height:36 }}/>
          <div style={{ fontSize:12, color:"#9ca3af" }}>{l}</div>
        </div>
      ))}
    </div>
  );
}

// ════════════════════════════════════════════════════════════
// MAIN PAGE
// ════════════════════════════════════════════════════════════
export default function ReportsPage() {
  const now = new Date();
  const [tab, setTab] = useState("daily");

  const [dailyDate, setDailyDate] = useState(now.toISOString().slice(0,10));
  const [dailyRep,  setDailyRep]  = useState(null);
  const [monYear,   setMonYear]   = useState(now.getFullYear());
  const [monMonth,  setMonMonth]  = useState(now.getMonth()+1);
  const [monRep,    setMonRep]    = useState(null);
  const [ayList,    setAyList]    = useState([]);
  const [ayId,      setAyId]      = useState("");
  const [annRep,    setAnnRep]    = useState(null);
   const [schoolName, setSchoolName] = useState("");

  // Classwise
  const [classList,   setClassList]   = useState([]);
  const [selectedCls, setSelectedCls] = useState([]); // array of class ids
  const [cwSubTab,    setCwSubTab]    = useState("daily");
  const [cwDailyDate, setCwDailyDate] = useState(now.toISOString().slice(0,10));
  const [cwMonYear,   setCwMonYear]   = useState(now.getFullYear());
  const [cwMonMonth,  setCwMonMonth]  = useState(now.getMonth()+1);
  const [cwAyId,      setCwAyId]      = useState("");
  const [cwResults,   setCwResults]   = useState([]); // array of results per class
   
  const [loading, setLoading] = useState(false);
  

useEffect(() => {
  const token = localStorage.getItem("token");
  const hdr = { Authorization:`Bearer ${token}` };
  
  // School name fetch
  fetch("/api/school", { headers: hdr })
    .then(r => r.json())
    .then(d => {
      const s = d.data;
      if (s) setSchoolName(s.name_kannada || s.name_english || "");
    })
    .catch(() => {});

  // ... ಬಾಕಿ existing fetch calls ಹಾಗೇ ಇರಲಿ
}, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const hdr = { Authorization:`Bearer ${token}` };
    fetch("/api/academic-years", { headers:hdr })
      .then(r=>r.json()).then(d=>{
        const list = d.data||[];
        setAyList(list);
        const today = new Date();
        const active = list.find(a=>{
          const s=new Date(String(a.start_date).slice(0,10));
          const e=new Date(String(a.end_date).slice(0,10));
          return s<=today && e>=today;
        });
        const best = active||list.find(a=>a.is_current)||list[0];
        if (best) { setAyId(String(best.id)); setCwAyId(String(best.id)); }
      }).catch(()=>{});
    fetch("/api/classes/list", { headers:hdr })
      .then(r=>r.json()).then(d=>{
        const list = d.data||[];
        console.log("Class List:", list);
        setClassList(list);
        // Select all by default
        setSelectedCls(list.map(c=>String(c.id)));
      }).catch(()=>{});
  }, []);

  const load = async (fn, setter, msg) => {
    setLoading(true);
    try {
      const { data } = await fn();
      setter(data.data);
      toast.success(msg+" ✅");
    } catch { toast.error("ವರದಿ ತಯಾರಾಗಲಿಲ್ಲ"); }
    finally { setLoading(false); }
  };

  // Fetch classwise for multiple selected classes
  const fetchCwMulti = async (fromDate, toDate, label) => {
    console.log('fetchCwMulti:', fromDate, toDate);
    if (selectedCls.length === 0) { toast.error("ತರಗತಿ ಆಯ್ಕೆ ಮಾಡಿ"); return; }
    setLoading(true);
    setCwResults([]);
    try {
      const token = localStorage.getItem("token");
      const results = await Promise.all(
        selectedCls.map(async (cid) => {
          const res = await fetch(
            `/api/reports/classwise?class_id=${cid}&from_date=${fromDate}&to_date=${toDate}`,
            { headers:{ Authorization:`Bearer ${token}` } }
          );
          const d = await res.json();
          console.log(`class ${cid} response:`, d); // debug
          // ✅ Fix: d.data ಇದ್ದರೆ ಅದು, ಇಲ್ಲದಿದ್ದರೆ null return
          if (!d.success) return null;
          return d.data;
        })
      );
      // null values filter ಮಾಡಿ
      const valid = results.filter(r => r !== null && r !== undefined);
      console.log('valid results:', valid.length);
      if (valid.length === 0) {
        toast.error("ಆಯ್ಕೆ ಮಾಡಿದ ಅವಧಿಯಲ್ಲಿ ದಾಖಲು ಇಲ್ಲ");
        return;
      }
      setCwResults(valid);
      toast.success(`${valid.length} ತರಗತಿ ವರದಿ ✅`);
    } catch(e) { 
      console.error('fetchCwMulti error:', e);
      toast.error("ವರದಿ ತಯಾರಾಗಲಿಲ್ಲ"); 
    }
    finally { setLoading(false); }
  };

  const toggleClass = (id) => {
    setSelectedCls(prev =>
      prev.includes(String(id))
        ? prev.filter(c=>c!==String(id))
        : [...prev, String(id)]
    );
  };

  const toggleAll = () => {
    setSelectedCls(
      selectedCls.length === classList.length
        ? []
        : classList.map(c=>String(c.id))
    );
  };

  return (
    <div style={S.page} className="rep-page">
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:22, fontWeight:700, color:"#f9fafb", marginBottom:4 }}>📋 ವರದಿಗಳು</h1>
        <p style={{ fontSize:13, color:"#6b7280" }}>ದೈನಂದಿನ · ತಿಂಗಳ · ವಾರ್ಷಿಕ · ತರಗತಿವಾರು MDM ವರದಿ</p>
      </div>

      <div style={{ display:"flex", gap:8, marginBottom:24, flexWrap:"wrap" }}>
        <Tab active={tab==="daily"}     onClick={()=>setTab("daily")}>📆 ದೈನಂದಿನ</Tab>
        <Tab active={tab==="monthly"}   onClick={()=>setTab("monthly")}>📅 ತಿಂಗಳ</Tab>
        <Tab active={tab==="annual"}    onClick={()=>setTab("annual")}>📊 ವಾರ್ಷಿಕ</Tab>
        <Tab active={tab==="classwise"} onClick={()=>setTab("classwise")}>🏫 ತರಗತಿವಾರು</Tab>
      </div>

      {/* DAILY */}
      {tab==="daily" && (
        <>
          <div style={S.ctrl}>
            <div><div style={S.lbl}>ದಿನಾಂಕ</div>
              <input type="date" style={S.sel} value={dailyDate}
                onChange={e=>setDailyDate(e.target.value)} max={now.toISOString().slice(0,10)} />
            </div>
            <Btn disabled={loading} onClick={()=>load(()=>reportAPI.daily(dailyDate),setDailyRep,"ದೈನಂದಿನ ವರದಿ")}>
              {loading?"ತಯಾರಾಗುತ್ತಿದೆ...":"ವರದಿ ತೋರಿಸಿ"}
            </Btn>
            {dailyRep && <Btn variant="grey" onClick={()=>window.print()}>🖨️ ಮುದ್ರಿಸಿ</Btn>}
          </div>
          {dailyRep && <DailyReport report={dailyRep} date={dailyDate} schoolName={schoolName} />}
        </>
      )}

      {/* MONTHLY */}
      {tab==="monthly" && (
        <>
          <div style={S.ctrl}>
            <div><div style={S.lbl}>ತಿಂಗಳು</div>
              <select style={S.sel} value={monMonth} onChange={e=>setMonMonth(e.target.value)}>
                {KN_MONTHS.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
              </select>
            </div>
            <div><div style={S.lbl}>ವರ್ಷ</div>
              <select style={S.sel} value={monYear} onChange={e=>setMonYear(e.target.value)}>
                {[2024,2025,2026].map(y=><option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <Btn disabled={loading} onClick={()=>load(()=>reportAPI.monthly(monYear,monMonth),setMonRep,"ತಿಂಗಳ ವರದಿ")}>
              {loading?"ತಯಾರಾಗುತ್ತಿದೆ...":"ವರದಿ ತೋರಿಸಿ"}
            </Btn>
            {monRep && <Btn variant="grey" onClick={()=>window.print()}>🖨️ ಮುದ್ರಿಸಿ</Btn>}
            {/* Monthly tab ctrl ನಲ್ಲಿ — ಈಗ ಇರುವ buttons ನಂತರ add */}
{monRep && (
  <Btn variant="grey" onClick={() => {
    const token = localStorage.getItem("token");
    fetch(`/api/reports/monthly/excel?year=${monYear}&month=${monMonth}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(r => r.blob())
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `MDM_Monthly_${monYear}_${monMonth}.xlsx`;
      a.click();
    })
    .catch(() => toast.error("Excel ಡೌನ್‌ಲೋಡ್ ಆಗಲಿಲ್ಲ"));
  }}>
    📥 Excel
  </Btn>
)}
          </div>
          {monRep && <MonthlyReport report={monRep} year={monYear} month={monMonth} schoolName={schoolName} />}
         

        </>
      )}

      {/* ANNUAL */}
      {tab==="annual" && (
        <>
          <div style={S.ctrl}>
            <div><div style={S.lbl}>ಶೈಕ್ಷಣಿಕ ವರ್ಷ</div>
              <select style={S.sel} value={ayId} onChange={e=>setAyId(e.target.value)}>
                {ayList.length===0
                  ? <option value="">ಲೋಡ್ ಆಗುತ್ತಿದೆ...</option>
                  : ayList.map(a=><option key={a.id} value={a.id}>{a.year_label}{a.is_current?" (ಪ್ರಸ್ತುತ)":""}</option>)
                }
              </select>
            </div>
            <Btn disabled={loading||!ayId} onClick={()=>load(()=>reportAPI.annual(ayId),setAnnRep,"ವಾರ್ಷಿಕ ವರದಿ")}>
              {loading?"ತಯಾರಾಗುತ್ತಿದೆ...":"ವಾರ್ಷಿಕ ವರದಿ ತೋರಿಸಿ"}
            </Btn>
            {annRep && <Btn variant="grey" onClick={()=>window.print()}>🖨️ ಮುದ್ರಿಸಿ</Btn>}
          </div>
          {annRep && <AnnualReport report={annRep} schoolName={schoolName} />}
        </>
      )}

      {/* CLASS-WISE */}
      {tab==="classwise" && (
        <>
          {/* Class selector with checkboxes */}
          <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)",
                        borderRadius:12, padding:"14px 16px", marginBottom:16 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between",
                          marginBottom:10 }}>
              <div style={{ fontSize:12, color:"#9ca3af", fontWeight:600 }}>
                ತರಗತಿ ಆಯ್ಕೆ ಮಾಡಿ ({selectedCls.length}/{classList.length})
              </div>
              <button onClick={toggleAll} style={{
                padding:"4px 12px", borderRadius:6, fontSize:12, cursor:"pointer",
                background:"rgba(74,222,128,0.1)", border:"1px solid rgba(74,222,128,0.3)",
                color:"#4ade80"
              }}>
                {selectedCls.length===classList.length?"ಎಲ್ಲವನ್ನು ತೆಗೆ":"ಎಲ್ಲ ಆಯ್ಕೆ"}
              </button>
            </div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
  {[...classList]
  .sort((a, b) => Number(a.id) - Number(b.id))
  .map(c => {
    const sel = selectedCls.includes(String(c.id));
    return (

      <button
        key={c.id}
        onClick={() => toggleClass(c.id)}
        style={{
          padding:"6px 14px",
          borderRadius:8,
          fontSize:13,
          cursor:"pointer",
          fontWeight:sel?600:400,
          border:sel?"1px solid rgba(74,222,128,0.5)":"1px solid rgba(255,255,255,0.15)",
          background:sel?"rgba(74,222,128,0.12)":"rgba(255,255,255,0.03)",
          color:sel?"#4ade80":"#9ca3af",
        }}
      >
        {sel?"✓ ":""}{c.name_kannada}
      </button>
    );
              })}
            </div>
          </div>

          {/* Sub-tabs */}
          <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
            {[["daily","📆 ದೈನಂದಿನ"],["monthly","📅 ತಿಂಗಳ"],["annual","📊 ವಾರ್ಷಿಕ"]].map(([k,label])=>(
              <button key={k} onClick={()=>{ setCwSubTab(k); setCwResults([]); }} style={{
                padding:"7px 16px", borderRadius:8, fontSize:12, cursor:"pointer",
                fontWeight:cwSubTab===k?600:400,
                border:cwSubTab===k?"1px solid rgba(74,222,128,0.4)":"1px solid rgba(255,255,255,0.1)",
                background:cwSubTab===k?"rgba(74,222,128,0.08)":"transparent",
                color:cwSubTab===k?"#4ade80":"#9ca3af",
              }}>{label}</button>
            ))}
          </div>

          {/* Daily */}
          {cwSubTab==="daily" && (
            <div style={S.ctrl}>
              <div><div style={S.lbl}>ದಿನಾಂಕ</div>
                <input type="date" style={S.sel} value={cwDailyDate}
                  onChange={e=>setCwDailyDate(e.target.value)}
                  max={now.toISOString().slice(0,10)} />
              </div>
              <Btn disabled={loading||selectedCls.length===0}
                onClick={()=>fetchCwMulti(cwDailyDate,cwDailyDate,fmtDate(cwDailyDate))}>
                {loading?"ತಯಾರಾಗುತ್ತಿದೆ...":"ವರದಿ ತೋರಿಸಿ"}
              </Btn>
              {cwResults.length>0 && <Btn variant="grey" onClick={()=>window.print()}>🖨️ ಮುದ್ರಿಸಿ</Btn>}
            </div>
          )}

          {/* Monthly */}
          {cwSubTab==="monthly" && (
            <div style={S.ctrl}>
              <div><div style={S.lbl}>ತಿಂಗಳು</div>
                <select style={S.sel} value={cwMonMonth} onChange={e=>setCwMonMonth(e.target.value)}>
                  {KN_MONTHS.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                </select>
              </div>
              <div><div style={S.lbl}>ವರ್ಷ</div>
                <select style={S.sel} value={cwMonYear} onChange={e=>setCwMonYear(e.target.value)}>
                  {[2024,2025,2026].map(y=><option key={y} value={y}>{y}</option>)}
                </select>
              </div>
              <Btn disabled={loading||selectedCls.length===0} onClick={()=>{
                const f=`${cwMonYear}-${String(cwMonMonth).padStart(2,"0")}-01`;
                const t=new Date(cwMonYear,cwMonMonth,0).toISOString().slice(0,10);
                fetchCwMulti(f,t,`${KN_MONTHS[cwMonMonth]} ${cwMonYear}`);
              }}>
                {loading?"ತಯಾರಾಗುತ್ತಿದೆ...":"ವರದಿ ತೋರಿಸಿ"}
              </Btn>
              {cwResults.length>0 && <Btn variant="grey" onClick={()=>window.print()}>🖨️ ಮುದ್ರಿಸಿ</Btn>}
            </div>
          )}

          {/* Annual */}
          {cwSubTab==="annual" && (
            <div style={S.ctrl}>
              <div><div style={S.lbl}>ಶೈಕ್ಷಣಿಕ ವರ್ಷ</div>
                <select style={S.sel} value={cwAyId} onChange={e=>setCwAyId(e.target.value)}>
                  {ayList.map(a=><option key={a.id} value={a.id}>{a.year_label}{a.is_current?" (ಪ್ರಸ್ತುತ)":""}</option>)}
                </select>
              </div>
              <Btn disabled={loading||selectedCls.length===0||!cwAyId} onClick={()=>{
  const ay = ayList.find(a=>String(a.id)===String(cwAyId));
  if (!ay) return;
  const s = toDateStr(ay.start_date);
  const e = toDateStr(ay.end_date);
  console.log('Annual date range:', s, 'to', e); // debug
  if (!s || !e) { toast.error("ದಿನಾಂಕ ಸರಿಯಿಲ್ಲ"); return; }
  fetchCwMulti(s, e, ay.year_label||"ವಾರ್ಷಿಕ");
}}>
              
                {loading?"ತಯಾರಾಗುತ್ತಿದೆ...":"ವರದಿ ತೋರಿಸಿ"}
              </Btn>
              {cwResults.length>0 && <Btn variant="grey" onClick={()=>window.print()}>🖨️ ಮುದ್ರಿಸಿ</Btn>}
            </div>
          )}

          {/* Results — one section per class */}
          {/* Results — one section per class */}
          <div className="print-wrapper">
            {cwResults.map((rep,i)=>(
              <div key={i} style={{ marginBottom:32 }}>
                <ClasswiseReport report={rep}
                schoolName={schoolName}
                subTab={cwSubTab}
                  label={cwSubTab==="daily"
                    ? `ದಿನಾಂಕ: ${fmtDate(cwDailyDate)}`
                    : cwSubTab==="monthly"
                    ? `${KN_MONTHS[cwMonMonth]} ${cwMonYear}`
                    : ayList.find(a=>String(a.id)===String(cwAyId))?.year_label||"ವಾರ್ಷಿಕ"}
                />
                {i < cwResults.length-1 && (
                  <div className="no-print" style={{ borderBottom:"2px dashed rgba(255,255,255,0.1)", margin:"24px 0" }}/>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════
// CLASSWISE REPORT
// ════════════════════════════════════════════════════════════
function ClasswiseReport({ report, label, schoolName, subTab }) {
  const cls       = report.class     || {};
  const items     = report.items     || [];
  const dateRows  = report.date_rows || [];
  const grand     = report.grand     || {};
  const suppItems = report.supp_items || [];
   

  return (
    <div className="printable">

      {/* School name — print ನಲ್ಲಿ ಮಾತ್ರ ಕಾಣಿಸುತ್ತದೆ */}
      <div className="print-school-header" style={{ display:"none" }}>
        <div style={{ fontSize:16, fontWeight:700, color:"#1a4a2a" }}>
          ಕರ್ನಾಟಕ ಸರ್ಕಾರ — ಅಕ್ಷರ ದಾಸೋಹ ಯೋಜನೆ
        </div>
        {schoolName && (
          <div style={{ fontSize:14, fontWeight:600, color:"#1a4a2a", marginTop:4 }}>
            {schoolName}
          </div>
        )}
      </div>

      <RptHeader title={`🏫 ${cls.name_kannada||""} — ತರಗತಿವಾರು ವರದಿ`} sub={label} />
      
      {/* ... ಬಾಕಿ ಎಲ್ಲಾ ಹಾಗೇ */}
      {/* Summary cards */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:10, marginBottom:20 }}>
       <SumCard icon="📅" label="ಕಾರ್ಯ ದಿನಗಳು" value={dateRows.length} />
<SumCard icon="👥" label="ಒಟ್ಟು ಹಾಜರಿ"   value={grand.total||0} />
<SumCard icon="💰" label="ಒಟ್ಟು ವೆಚ್ಚ"    value={`₹${parseFloat(grand.cost||0).toFixed(2)}`} green />


{suppItems.map(si => (
  <SumCard key={si.id} icon=""
    label={si.name_kannada}
    value={`${grand.supplementary?.[si.name_kannada] || 0} ಮಕ್ಕಳು`}
  />
))}
      </div>

      {dateRows.length > 0 ? (
        <>
          {/* Main food table */}
<div style={{ marginBottom:24 }}>
  <div style={S.secTitle}>📋 ದಿನಾಂಕವಾರು ಹಾಜರಾತಿ ಮತ್ತು ಆಹಾರ ವಿವರ</div>
  <RepTable
    heads={[
  {label:"ದಿನಾಂಕ"},{label:"ದಿನ"},
  {label:"ಒಟ್ಟು ಹಾಜರಿ",num:true},
  ...items.flatMap(it=>[
    {label:`${it.name_kannada} (ಪ್ರಮಾಣ)`, num:true},
    {label:`${it.name_kannada} (₹)`, num:true},
  ]),
  {label:"ದಿನ ವೆಚ್ಚ",num:true},
]}
    rows={dateRows.map(row=>{
  const food = row.food||{};
  return [
    fmtDate(row.date),
    new Date(row.date).toLocaleDateString("kn-IN",{weekday:"short"}),
    <strong>{row.total||0}</strong>,
    ...items.flatMap(it=>{
      const fd = food[it.name_kannada];
      return [
        fd ? qtyDisp(fd.qty, it.unit_type) : "—",
        fd && fd.cost > 0 ? `₹${parseFloat(fd.cost).toFixed(2)}` : "—",
      ];
    }),
    row.day_cost>0 ? `₹${parseFloat(row.day_cost).toFixed(2)}` : "—",
  ];
})}
    totalRow={[
  "ಒಟ್ಟು ಮೊತ್ತ","",
  <strong>{grand.total||0}</strong>,
  ...items.flatMap(it=>{
    const tq = dateRows.reduce((s,r)=>s+parseFloat(r.food?.[it.name_kannada]?.qty||0),0);
    const tc = dateRows.reduce((s,r)=>s+parseFloat(r.food?.[it.name_kannada]?.cost||0),0);
    return [
      tq>0 ? qtyDisp(tq, it.unit_type) : "—",
      tc>0 ? <strong>₹{tc.toFixed(2)}</strong> : "—",
    ];
  }),
  <strong>₹{parseFloat(grand.cost||0).toFixed(2)}</strong>,
]}
  />
</div>
          
        </>
      ) : (
        <div style={{ textAlign:"center",color:"#6b7280",padding:"32px 0",fontSize:14 }}>
          ಆಯ್ಕೆ ಮಾಡಿದ ಅವಧಿಯಲ್ಲಿ ದಾಖಲು ಇಲ್ಲ
        </div>
      )}
      <SignBlock />
    </div>
  );
}

// ════════════════════════════════════════════════════════════
// DAILY REPORT
// ════════════════════════════════════════════════════════════
function DailyReport({ report, date, schoolName}) {
  const fmt = new Date(date).toLocaleDateString("kn-IN",
    { weekday:"long", day:"numeric", month:"long", year:"numeric" });
  const classWise    = report.class_wise    || [];
  const groupTotals  = report.group_totals  || [];

  const itemsByGroup = report.items_by_group|| [];
  const itemsFlat    = report.items         || [];
  const gMap = {};
  itemsByGroup.forEach(i=>{
    if (!gMap[i.group_id]) gMap[i.group_id]={ name:i.group_name, order:i.group_order, items:[] };
    gMap[i.group_id].items.push(i);
  });
  const groupsWithFood = Object.values(gMap).sort((a,b)=>a.order-b.order);
  
  return (
    <div className="printable">
        <div className="print-school-header" style={{ display:"none" }}>
        <div style={{ fontSize:16, fontWeight:700 }}>ಕರ್ನಾಟಕ ಸರ್ಕಾರ — ಅಕ್ಷರ ದಾಸೋಹ ಯೋಜನೆ</div>
        {schoolName && <div style={{ fontSize:14, fontWeight:600, marginTop:4 }}>{schoolName}</div>}
        
      </div>
      <RptHeader title="📋 ಅಕ್ಷರ ದಾಸೋಹ — ದೈನಂದಿನ ವರದಿ" sub={fmt} />
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:10, marginBottom:20 }}>
        {groupTotals.map(g=><SumCard key={g.group_id} icon="👥" label={g.group_name} value={g.total_students||0} />)}
        <SumCard icon="👥" label="ಒಟ್ಟು ಮಕ್ಕಳು" value={report.total_students||0} />
       

        <SumCard icon="💰" label="ಒಟ್ಟು ವೆಚ್ಚ" value={`₹${parseFloat(report.total_cost||0).toFixed(2)}`} green />
      </div>
      {classWise.length>0 && (
        <div style={{ marginBottom:24 }}>
          <div style={S.secTitle}>🏫 ತರಗತಿವಾರು ಹಾಜರಾತಿ</div>
          <RepTable
            heads={[{label:"ತರಗತಿ"},{label:"ಗುಂಪು"},{label:"ಒಟ್ಟು",num:true}]}
rows={classWise.map(c=>[
  c.class_name,
  c.group_name?<GBadge name={c.group_name} order={c.group_order||1}/>:<span style={{color:"#6b7280",fontSize:12}}>ಗುಂಪು ಇಲ್ಲ</span>,
  <strong>{c.total_present}</strong>,
])}
totalRow={["ಒಟ್ಟು","",<strong>{report.total_students||0}</strong>]}
          />
        </div>
      )}
      {groupsWithFood.length>0 ? (
        groupsWithFood.map(g=>(
          <div key={g.name} style={{ marginBottom:20 }}>
            <div style={S.secTitle}><span>🍽️ ಆಹಾರ ವಿವರ</span><GBadge name={g.name} order={g.order}/></div>
            <RepTable
              heads={[{label:"ಕ್ರ.ಸಂ"},{label:"ಆಹಾರ ಪದಾರ್ಥ"},{label:"ಪ್ರಮಾಣ",num:true},{label:"ವೆಚ್ಚ (₹)",num:true}]}
              rows={g.items.map((it,i)=>[i+1,it.item_name_kannada,
                <strong>{qtyDisp(it.display_quantity,it.display_unit)}</strong>,
                `₹${parseFloat(it.total_cost||0).toFixed(2)}`])}
              totalRow={["","ಒಟ್ಟು","",<strong>₹{g.items.reduce((s,i)=>s+parseFloat(i.total_cost||0),0).toFixed(2)}</strong>]}
            />
          </div>
        ))
      ):itemsFlat.length>0?(
        <div style={{ marginBottom:20 }}>
          <div style={S.secTitle}>🍽️ ಇಂದಿನ ಆಹಾರ ವಿವರ</div>
          <RepTable
            heads={[{label:"ಕ್ರ.ಸಂ"},{label:"ಆಹಾರ ಪದಾರ್ಥ"},{label:"ಪ್ರಮಾಣ",num:true},{label:"ವೆಚ್ಚ",num:true}]}
            rows={itemsFlat.map((it,i)=>[i+1,it.item_name_kannada||it.name_kannada,
              <strong>{qtyDisp(it.display_quantity||it.display_quantity,it.unit_type)}</strong>,
              `₹${parseFloat(it.total_cost||0).toFixed(2)}`])}
            totalRow={["","ಒಟ್ಟು ವೆಚ್ಚ","",<strong>₹{parseFloat(report.total_cost||0).toFixed(2)}</strong>]}
          />
        </div>
      ):(
        <div style={{ textAlign:"center",color:"#6b7280",padding:"32px 0",fontSize:14 }}>ಈ ದಿನ ಆಹಾರ ವಿತರಣೆ ದಾಖಲು ಇಲ್ಲ</div>
      )}
      {/* Supplementary summary in daily report */}
{(() => {
  // class_wise ನಲ್ಲಿ supplementary data ಇದ್ದರೆ show ಮಾಡಿ
  const allSupp = (classWise || []).flatMap(c => c.supplementary || []);
  if (allSupp.length === 0) return null;

  // Group by item
  const suppTotals = {};
  allSupp.forEach(s => {
    if (!suppTotals[s.item_name]) suppTotals[s.item_name] = 0;
    suppTotals[s.item_name] += s.student_count || 0;
  });

  return (
    <div style={{ marginBottom:20 }}>
      <div style={S.secTitle}>  ಹೆಚ್ಚುವರಿ ಆಹಾರ ವಿತರಣೆ — ಸಾರಾಂಶ</div>
      <RepTable
        heads={[
          {label:"ತರಗತಿ"},
          ...Object.keys(suppTotals).map(n=>({label:n,num:true})),
        ]}
        rows={classWise.filter(c=>(c.supplementary||[]).length>0).map(c=>{
          const sm = {};
          (c.supplementary||[]).forEach(s=>{ sm[s.item_name]=s.student_count; });
          return [
            c.class_name,
            ...Object.keys(suppTotals).map(n=>sm[n]||"—"),
          ];
        })}
        totalRow={[
          "ಒಟ್ಟು",
          ...Object.entries(suppTotals).map(([,v])=><strong>{v}</strong>),
        ]}
      />
    </div>
  );
})()}
      <SignBlock />
    </div>
  );
}

// ════════════════════════════════════════════════════════════
// MONTHLY REPORT
// ════════════════════════════════════════════════════════════
function MonthlyReport({ report, year, month,schoolName}) {
  const groupSummary = report.group_summary||[];
  const foodByGroup  = report.food_by_group||[];
  const itemSummary  = report.item_summary ||[];
  const gfMap={};
  foodByGroup.forEach(f=>{
    if (!gfMap[f.group_id]) gfMap[f.group_id]={ name:f.group_name, order:f.group_order, items:[] };
    gfMap[f.group_id].items.push(f);
  });
  const groupsFood=Object.values(gfMap).sort((a,b)=>a.order-b.order);
  return (
    <div className="printable">
      <div className="print-school-header" style={{ display:"none" }}>
        <div>ಕರ್ನಾಟಕ ಸರ್ಕಾರ — ಅಕ್ಷರ ದಾಸೋಹ ಯೋಜನೆ</div>
        {schoolName && <div>{schoolName}</div>}
      </div>
      
      <RptHeader title={`📅 ${KN_MONTHS[month]} ${year} — ತಿಂಗಳ ವರದಿ`} sub="ಕರ್ನಾಟಕ ಸರ್ಕಾರ — ಅಕ್ಷರ ದಾಸೋಹ ಯೋಜನೆ" />
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:10, marginBottom:20 }}>
        <SumCard icon="📅" label="ಕಾರ್ಯ ದಿನಗಳು" value={report.attendance?.working_days??0} />
        {groupSummary.map(g=><SumCard key={g.group_id} icon="👥" label={g.group_name+" ಒಟ್ಟು"} value={g.total_students||0} />)}
        <SumCard icon="👥" label="ಒಟ್ಟು ಮಕ್ಕಳು" value={report.attendance?.total_students??0} />
        <SumCard icon="💰" label="ಒಟ್ಟು ವೆಚ್ಚ" value={`₹${parseFloat(report.total_cost||0).toFixed(2)}`} green />
      </div>
      {groupSummary.length>0 && (
        <div style={{ marginBottom:24 }}>
          <div style={S.secTitle}>🏫 ಗುಂಪುವಾರು ಹಾಜರಾತಿ ಸಾರಾಂಶ</div>
          <RepTable
            heads={[{label:"ಗುಂಪು"},{label:"ಒಟ್ಟು ಹಾಜರಿ",num:true},{label:"ಕಾರ್ಯ ದಿನ",num:true},{label:"ದಿನ ಸರಾಸರಿ",num:true}]}
            rows={groupSummary.map(g=>[
              <GBadge name={g.group_name} order={g.group_order||1}/>,
              g.total_students,report.attendance?.working_days??0,
              Math.round((Number(g.total_students)||0)/Math.max(report.attendance?.working_days||1,1))])}
            totalRow={["ಒಟ್ಟು",groupSummary.reduce((s,g)=>s+Number(g.total_students||0),0),
              report.attendance?.working_days??0,
              Math.round((report.attendance?.total_students||0)/Math.max(report.attendance?.working_days||1,1))]}
          />
        </div>
      )}
      {groupsFood.length>0?(
        groupsFood.map(g=>(
          <div key={g.name} style={{ marginBottom:24 }}>
            <div style={S.secTitle}><span>🍽️ ಆಹಾರ ಬಳಕೆ</span><GBadge name={g.name} order={g.order}/></div>
            <RepTable
              heads={[{label:"ಕ್ರ.ಸಂ"},{label:"ಆಹಾರ ಪದಾರ್ಥ"},{label:"ಒಟ್ಟು ಪ್ರಮಾಣ",num:true},{label:"ಒಟ್ಟು ವೆಚ್ಚ (₹)",num:true}]}
              rows={g.items.map((it,i)=>[i+1,it.item_name_kannada,
               qtyDisp(it.total_display_qty,it.display_unit),
                `₹${parseFloat(it.total_cost||0).toFixed(2)}`])}
              totalRow={["","ಒಟ್ಟು","",<strong>₹{g.items.reduce((s,i)=>s+parseFloat(i.total_cost||0),0).toFixed(2)}</strong>]}
            />
          </div>
        ))
      ):(
        <div style={{ marginBottom:24 }}>
          <div style={S.secTitle}>🍽️ ಆಹಾರ ಬಳಕೆ ಸಾರಾಂಶ</div>
          <RepTable
            heads={[{label:"ಕ್ರ.ಸಂ"},{label:"ಆಹಾರ ಪದಾರ್ಥ"},{label:"ಒಟ್ಟು ಪ್ರಮಾಣ",num:true},{label:"ಒಟ್ಟು ವೆಚ್ಚ",num:true}]}
            rows={itemSummary.map((it,i)=>[i+1,it.name_kannada,
             qtyDisp(it.total_display_qty||it.display_quantity,it.display_unit),
              `₹${parseFloat(it.total_cost||0).toFixed(2)}`])}
            totalRow={["","ಒಟ್ಟು","",<strong>₹{parseFloat(report.total_cost||0).toFixed(2)}</strong>]}
          />
        </div>
      )}
      {/* Monthly supplementary summary */}
{(() => {
  // Monthly report ನಲ್ಲಿ supplementary data fetch ಮಾಡಲು
  // ReportsPage state ನಿಂದ pass ಮಾಡಬೇಕು — ಮೊದಲು check
  if (!report.supplementary_summary || report.supplementary_summary.length === 0) return null;
  return (
    <div style={{ marginBottom:24 }}>
      <div style={S.secTitle}>  ಹೆಚ್ಚುವರಿ ಆಹಾರ ಮಾಸಿಕ ಸಾರಾಂಶ</div>
      <RepTable
        heads={[{label:"ಆಹಾರ ಪದಾರ್ಥ"},{label:"ಒಟ್ಟು ಮಕ್ಕಳು",num:true}]}
        rows={report.supplementary_summary.map(s=>[
          s.name_kannada,
          <strong>{s.total_students}</strong>,
        ])}
        totalRow={[
          "ಒಟ್ಟು",
          <strong>{report.supplementary_summary.reduce((s,r)=>s+parseInt(r.total_students||0),0)}</strong>
        ]}
      />
    </div>
  );
})()}
{/* Class-wise daily table */}
{(report.class_daily_rows || []).length > 0 && (() => {
  const allItems = report.all_items || [];
  const rows = report.class_daily_rows || [];
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={S.secTitle}>📋 ತರಗತಿವಾರು ದಿನಾಂಕವಾರು ವಿವರ</div>
      
      <RepTable
        heads={[
          {label:"ದಿನಾಂಕ"}, {label:"ದಿನ"}, {label:"ತರಗತಿ"},
          {label:"ಒಟ್ಟು", num:true},
          ...allItems.flatMap(it=>[
            {label:`${it.name_kannada}(ಪ್ರ)`, num:true},
            {label:`${it.name_kannada}(₹)`, num:true},
          ]),
          {label:"ದಿನ ವೆಚ್ಚ", num:true},
        ]}
        rows={rows.map(row => [
          row.date_fmt,
          row.day_name,
          row.class_name,
          <strong>{row.total}</strong>,
          ...allItems.flatMap(it => {
            const fd = row.food[it.name_kannada];
            return [
              fd ? qtyDisp(fd.qty, it.unit_type) : "—",
              fd && fd.cost > 0 ? `₹${fd.cost.toFixed(2)}` : "—",
            ];
          }),
          row.day_cost > 0 ? `₹${row.day_cost.toFixed(2)}` : "—",
        ])}
        totalRow={[
          "ಒಟ್ಟು","","",
          <strong>{rows.reduce((s,r)=>s+r.total,0)}</strong>,
          ...allItems.flatMap(it=>{
            const tq = rows.reduce((s,r)=>s+(r.food[it.name_kannada]?.qty||0),0);
            const tc = rows.reduce((s,r)=>s+(r.food[it.name_kannada]?.cost||0),0);
            return [
              tq>0 ? qtyDisp(tq, it.unit_type) : "—",
              tc>0 ? <strong>₹{tc.toFixed(2)}</strong> : "—",
            ];
          }),
          <strong>₹{rows.reduce((s,r)=>s+r.day_cost,0).toFixed(2)}</strong>,
        ]}
      />
    </div>
  );
})()}
      <SignBlock />
    </div>
  );
}

// ════════════════════════════════════════════════════════════
// ANNUAL REPORT
// ════════════════════════════════════════════════════════════
function AnnualReport({ report, schoolName }) {
  const months=report.months||[], groups=report.groups||[], ay=report.academic_year||{};
  const tWd=months.reduce((s,m)=>s+parseInt(m.working_days||0),0);
  const tAll=months.reduce((s,m)=>s+parseInt(m.total_students||0),0);
  const tCost=months.reduce((s,m)=>s+parseFloat(m.total_cost||0),0);
  const groupTotals=groups.map(g=>({...g,total:months.reduce((s,m)=>s+parseInt(m[`group_${g.id}_students`]||0),0)}));
  return (
    <div className="printable">
      <div className="print-school-header" style={{ display:"none" }}>
        <div>ಕರ್ನಾಟಕ ಸರ್ಕಾರ — ಅಕ್ಷರ ದಾಸೋಹ ಯೋಜನೆ</div>
        {schoolName && <div>{schoolName}</div>}
      </div>
      <RptHeader title="📊 ವಾರ್ಷಿಕ MDM ಸಾರಾಂಶ"
        sub={`ಶೈಕ್ಷಣಿಕ ವರ್ಷ: ${ay.year_label||""} (${String(ay.start_date||"").slice(0,10)} ರಿಂದ ${String(ay.end_date||"").slice(0,10)} ವರೆಗೆ)`} />
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:10, marginBottom:20 }}>
        <SumCard icon="📅" label="ಒಟ್ಟು ಕಾರ್ಯ ದಿನ" value={tWd} />
        {groupTotals.map(g=><SumCard key={g.id} icon="👥" label={g.name_kannada+" ಒಟ್ಟು"} value={g.total.toLocaleString()} />)}
        <SumCard icon="👥" label="ಒಟ್ಟು ಹಾಜರಿ" value={tAll.toLocaleString()} />
        <SumCard icon="💰" label="ಒಟ್ಟು ವೆಚ್ಚ" value={`₹${tCost.toFixed(2)}`} green />
        
      </div>
      <div style={S.secTitle}>📋 ತಿಂಗಳವಾರು ವಿವರ</div>
      <RepTable
        heads={[{label:"ತಿಂಗಳು"},{label:"ಕಾರ್ಯ ದಿನ",num:true},
          ...groups.map(g=>({label:g.name_kannada,num:true})),
          {label:"ಒಟ್ಟು ಹಾಜರಿ",num:true},{label:"ದಿನ ಸರಾಸರಿ",num:true},
          {label:"ಒಟ್ಟು ವೆಚ್ಚ",num:true},{label:"ಪ್ರತಿ ಮಗು",num:true}]}
        rows={months.map(m=>{
          const s=parseInt(m.total_students||0),d=parseInt(m.working_days||0),c=parseFloat(m.total_cost||0);
          return [`${KN_MONTHS[m.month]} ${m.year}`,d,
            ...groups.map(g=>parseInt(m[`group_${g.id}_students`]||0)),
            <strong>{s.toLocaleString()}</strong>,d>0?Math.round(s/d):0,
            `₹${c.toFixed(2)}`,s>0?`₹${(c/s).toFixed(2)}`:"₹0.00"];
        })}
        totalRow={["ಒಟ್ಟು ಮೊತ್ತ",tWd,...groupTotals.map(g=>g.total.toLocaleString()),
          <strong>{tAll.toLocaleString()}</strong>,tWd>0?Math.round(tAll/tWd):0,
          <strong>₹{tCost.toFixed(2)}</strong>,tAll>0?`₹${(tCost/tAll).toFixed(2)}`:"₹0.00"]}
      />
      <SignBlock />
    </div>
  );
}